var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CrudList',{attrs:{"title":"Notificaciones de pedidos de request","storeName":"Notifications_request_cms","canAdd":false,"canEdit":false,"canDelete":true,"canShow":true,"next-link":"/admin/push_notifications","breadcrumbs":[
      {
        text: 'Marketing y comunicación',
        disabled: false,
        href: '/admin/notifications_request_cms'
      },
      {
        text: 'Notificaciones de pedidos de request',
        disabled: false,
        href: '#'
      }
    ]},scopedSlots:_vm._u([{key:"user",fn:function({ item }){return [_c('p',[_vm._v(" "+_vm._s(item.user_id && item.user_id ? `${item.user_id.name || ""} ${item.user_id.last_name || ""}` : "")+" ")])]}},{key:"description",fn:function({ item }){return [_c('v-container',{staticClass:"overflow-y-auto",staticStyle:{"max-height":"210px"},attrs:{"id":"scroll-target"}},[_c('v-row',{directives:[{name:"scroll",rawName:"v-scroll:#scroll-target",value:(_vm.onScroll),expression:"onScroll",arg:"#scroll-target"}]},[_c('p',[_vm._v(_vm._s(item.description))])])],1)]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }